import { gql } from '@grandvisionhq/graphql';

const timeSlots = gql`
  fragment TimeSlots on TimeSlot {
    from
    until
  }
`;
const GET_TIME_SLOTS = gql`
  query GetTimeSlots(
    $appointmentTypeId: ID!
    $date: String
    $opticianId: ID
    $storeCode: ID
    $storeId: ID
  ) {
    timeSlots(
      appointmentTypeId: $appointmentTypeId
      date: $date
      opticianId: $opticianId
      storeCode: $storeCode
      storeId: $storeId
    ) {
      ...TimeSlots
    }
  }
  ${timeSlots}
`;

export { GET_TIME_SLOTS };
//# sourceMappingURL=get-time-slots.js.map
